// @flow

import React from "react";

import { isEmpty, isNil } from "ramda";

import {
  SelecaoAjusteDePreco,
  SelecaoDeflacao,
  SelecaoNormalizacao,
  SelecaoCorrecaoMonetaria,
} from "../configuracoes";

import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
  ID_FONTE_FIDC_PADRAO,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSelecionados,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
  getUsarUltimaNegociacaoMes,
} from "../../../state";

export const criaFuncaoValidacaoSeriesComAjusteEFonteDeflatorCorrecao = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjusteEFonteDeflatorCorrecao = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const edicaoMedida = getEdicaoMedida(state);
  const ajustesPreco = getAjustesPrecoSelecionados(state) || [];
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);
  const ultimaNegociacao = getUsarUltimaNegociacaoMes(state);

  const configCorrecao =
    !isNil(edicaoMedida.corretorMonetario) &&
    edicaoMedida.corretorMonetario !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
      ? {
          correcaoMonetaria: edicaoMedida.corretorMonetario,
        }
      : {};
  const configDeflator =
    !isNil(edicaoMedida.deflator) &&
    edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
      ? {
          deflator: edicaoMedida.deflator,
        }
      : {};
  const configValorDataBase =
    !isNil(edicaoMedida.valorBaseDeflator) &&
    !isNil(edicaoMedida.dataBaseDeflator)
      ? {
          valorBaseDeflator: edicaoMedida.valorBaseDeflator,
          valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
          dataBaseDeflator: edicaoMedida.dataBaseDeflator,
          dataBaseDeflatorDataEspecifica:
            edicaoMedida.dataBaseDeflatorDataEspecifica,
        }
      : {};

  return medidas.flatMap(medida =>
    ajustesPreco.map(ajuste => {
      return {
        ...medida,
        tipoAjuste: exibirConfiguracoesAvancadas
          ? ajuste
          : ID_TIPO_AJUSTE_PRECO_PADRAO,
        fonteDeDadosFIDC: ID_FONTE_FIDC_PADRAO,
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ultimaNegociacao,
        ...analiseValorDaMedida(medida, state),
      };
    })
  );
};

const SeriesComAjusteEFonteDeflatorCorrecao = () => {
  return (
    <>
      <SelecaoAjusteDePreco />
      <div className="ConfiguracaoMedida__vertical-divider" />
      <div className="ConfiguracaoMedida__box">
        <div className="ConfiguracaoMedida--row">
          <SelecaoDeflacao exibirNormalizacao={false} />
          <SelecaoCorrecaoMonetaria />
        </div>
        <div className="ConfiguracaoMedida--row">
          <SelecaoNormalizacao
            forcarExibirNormalizacao={true}
            exibirOpcaoNenhum={true}
            utilizarEspacoTotal={true}
          />
        </div>
      </div>
    </>
  );
};

export default SeriesComAjusteEFonteDeflatorCorrecao;
